import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface UpdateTargetAttendanceResult {
  updateTargetAttendance: {
    event: {
      id: number;
      targetAttendance: number | null;
    };
    ok: boolean;
  };
}

export interface UpdateTargetAttendanceVariables {
  input: {
    eventId: number;
    targetAttendance?: number | null;
  };
}

const UpdateTargetAttendanceMutation = gql`
  mutation UpdateTargetAttendance($input: UpdateTargetAttendanceInputType!) {
    updateTargetAttendance(input: $input) {
      ok
      event {
        id
        targetAttendance
      }
    }
  }
`;

export const updateTargetAttendance = (
  variables: UpdateTargetAttendanceVariables
): Promise<UpdateTargetAttendanceResult> => {
  return gqlClient.request<UpdateTargetAttendanceResult>(UpdateTargetAttendanceMutation, variables);
};
